{
	"ariaCreatePersonalAIStyle": "Create Personal AI Style",
	"createPersonal": "Create Personal AI Style",
	"createYourOwn": "Create your own personal AI style.",
	"willLearnYourStyleAnd": "{{var0}} will learn your style and create an AI Style that edits like you⎯every time."
}
